import { Carousel, Grid } from "@scuf/common";
import BarStacked from "../../components/charts/BarStacked/BarStacked";

const EstadoProfit = () => {
  return (
    <>
      <Carousel
        className="carousel-custom carousel-custom-600 estado-profit--container"
        autoPlay={true}
        transitionTime={10000}
      >
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth="12"
                  sWidth="12"
                  mWidth="12"
                  lWidth="12"
                  xlWidth="12"
                >
                  <BarStacked
                    key={{ params: "020203" }}
                    url="sp_GetData"
                    body={{ params: "020203" }}
                    isCard="0"
                    titleCard="ESTADO PROFIT ULTIMAS 24 HORAS: CHUQUICAMATA"
                  />
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth="12"
                  sWidth="12"
                  mWidth="12"
                  lWidth="12"
                  xlWidth="12"
                >
                  <BarStacked
                    key={{ params: "020703" }}
                    url="sp_GetData"
                    body={{ params: "020703" }}
                    isCard="0"
                    titleCard="ESTADO PROFIT ULTIMAS 24 HORAS: RADOMIRO TOMIC"
                  />
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth="12"
                  sWidth="12"
                  mWidth="12"
                  lWidth="12"
                  xlWidth="12"
                >
                  <BarStacked
                    key={{ params: "020303" }}
                    url="sp_GetData"
                    body={{ params: "020303" }}
                    isCard="0"
                    titleCard="ESTADO PROFIT ULTIMAS 24 HORAS: MINISTRO HALES"
                  />
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth="12"
                  sWidth="12"
                  mWidth="12"
                  lWidth="12"
                  xlWidth="12"
                >
                  <BarStacked
                    key={{ params: "020803" }}
                    url="sp_GetData"
                    body={{ params: "020803" }}
                    isCard="0"
                    titleCard="ESTADO PROFIT ULTIMAS 24 HORAS: GABRIELA MISTRAL"
                  />
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth="12"
                  sWidth="12"
                  mWidth="12"
                  lWidth="12"
                  xlWidth="12"
                >
                  <BarStacked
                    key={{ params: "020403" }}
                    url="sp_GetData"
                    body={{ params: "020403" }}
                    isCard="0"
                    titleCard="ESTADO PROFIT ULTIMAS 24 HORAS: SALVADOR"
                  />
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth="12"
                  sWidth="12"
                  mWidth="12"
                  lWidth="12"
                  xlWidth="12"
                >
                  <BarStacked
                    key={{ params: "020503" }}
                    url="sp_GetData"
                    body={{ params: "020503" }}
                    isCard="0"
                    titleCard="ESTADO PROFIT ULTIMAS 24 HORAS: ANDINA"
                  />
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth="12"
                  sWidth="12"
                  mWidth="12"
                  lWidth="12"
                  xlWidth="12"
                >
                  <BarStacked
                    key={{ params: "020603" }}
                    url="sp_GetData"
                    body={{ params: "020603" }}
                    isCard="0"
                    titleCard="ESTADO PROFIT ULTIMAS 24 HORAS: TENIENTE"
                  />
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
      </Carousel>
    </>
  );
};

export default EstadoProfit;
